import { CommitmentStatus } from 'src/app/shared/model/reduction-action';

/** Icon and colours of each commitment status. */
export const COMMITMENT_STATUS_STYLE: Record<
  CommitmentStatus,
  { icon: string; badge: string; text: string }
> = {
  improvable: {
    icon: 'triangle-alert',
    badge: 'bg-warning-100 text-warning-700',
    text: 'text-warning-700',
  },
  respected: {
    icon: 'check',
    badge: 'bg-validation-100 text-validation-700',
    text: 'text-validation-700',
  },
  not_applicable: {
    icon: 'info',
    badge: 'bg-greyscale-100 text-greyscale-500',
    text: 'text-greyscale-500',
  },
};
